<template>
  <div class="markdown-renderer">
    <!-- 选择渲染为HTML或纯文本 -->
    <div v-if="outputType === 'html'" v-html="renderedContent"></div>
    <pre v-else>{{ renderedContent }}</pre>
  </div>
</template>

<script>
import MarkdownIt from 'markdown-it'

export default {
  name: 'MarkdownIt',
  props: {
    content: {
      type: String,
      required: true,
      default: ''
    },
    outputType: {
      type: String,
      default: 'html', // 'html' 或 'text'
      validator: value => ['html', 'text'].includes(value)
    },
    options: {
      type: Object,
      default: () => ({
        html: true, // 启用HTML标签
        xhtmlOut: false, // 使用XHTML闭合标签
        breaks: true, // 转换换行符为<br>
        linkify: true, // 自动链接识别
        typographer: true, // 印刷体替换
        quotes: '“”‘’' // 引号替换
      })
    },
    plugins: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      md: null
    }
  },
  computed: {
    renderedContent() {
      if (!this.content) return ''

      if (this.outputType === 'html') {
        return this.md.render(this.content)
      } else {
        return this.convertToText(this.content)
      }
    }
  },
  created() {
    this.initMarkdownIt()
  },
  methods: {
    initMarkdownIt() {
      // 初始化markdown-it实例
      this.md = new MarkdownIt(this.options)

      // 加载插件
      this.plugins.forEach(plugin => {
        if (Array.isArray(plugin)) {
          this.md.use(...plugin)
        } else {
          this.md.use(plugin)
        }
      })
    },

    convertToText(markdown) {
      // 自定义渲染器转换为纯文本
      const tempRenderer = new MarkdownIt({
        ...this.options,
        html: false,
        linkify: false
      })

      // 自定义渲染规则
      const originalRenderer = tempRenderer.renderer.rules

      tempRenderer.renderer.rules = {
        ...originalRenderer,
        heading_open: () => '',
        heading_close: () => '\n\n',
        paragraph_open: () => '',
        paragraph_close: () => '\n\n',
        list_item_open: () => '- ',
        list_item_close: () => '\n',
        strong_open: () => '',
        strong_close: () => '',
        em_open: () => '',
        em_close: () => '',
        link_open: () => '',
        link_close: (tokens, idx, options, env, self) => {
          const token = tokens[idx]
          return token.content || ''
        },
        image: () => '[图片]',
        code_inline: (tokens, idx) => tokens[idx].content,
        fence: (tokens, idx) => tokens[idx].content + '\n\n'
      }

      return tempRenderer.render(markdown).trim()
    }
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.initMarkdownIt()
      }
    },
    plugins: {
      deep: true,
      handler() {
        this.initMarkdownIt()
      }
    }
  }
}
</script>

<style scoped>
.markdown-renderer >>> pre {
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 4px;
  overflow-x: auto;
}

.markdown-renderer >>> code {
  font-family: monospace;
  background-color: rgba(27, 31, 35, 0.05);
  padding: 0.2em 0.4em;
  border-radius: 3px;
}

.markdown-renderer >>> blockquote {
  border-left: 4px solid #dfe2e5;
  color: #6a737d;
  padding: 0 1em;
  margin-left: 0;
}
</style>
